var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-container",
    [
      _c("v-breadcrumbs", {
        staticClass: "ml-n7 mt-n5",
        attrs: { items: _vm.breadcrumbItems, large: "" },
        scopedSlots: _vm._u([
          {
            key: "item",
            fn: function(ref) {
              var item = ref.item
              return [
                _c(
                  "v-breadcrumbs-item",
                  {
                    class: !item.disabled ? "cursor-pointer" : "",
                    attrs: { href: item.href, disabled: item.disabled },
                    on: {
                      click: function() {
                        return (_vm.step = 0)
                      }
                    }
                  },
                  [
                    !item.disabled && _vm.step != 0
                      ? _c("v-icon", { attrs: { size: "35px" } }, [
                          _vm._v("mdi-chevron-left")
                        ])
                      : _vm._e(),
                    _vm._v(" " + _vm._s(item.text) + " ")
                  ],
                  1
                )
              ]
            }
          }
        ])
      }),
      _c(
        "v-stepper",
        {
          staticClass: "elevation-0 transparent ma-0 pa-0",
          model: {
            value: _vm.step,
            callback: function($$v) {
              _vm.step = $$v
            },
            expression: "step"
          }
        },
        [
          _c(
            "v-stepper-content",
            { staticClass: "ma-0 pa-0", attrs: { step: "0" } },
            [
              _c(
                "section-title",
                { attrs: { icon: "mdi-clipboard-plus-outline" } },
                [_vm._v(" INFORMES DE SALUD Y GESTIÓN DEL ÚLTIMO AÑO ")]
              ),
              _c(
                "v-card",
                [
                  _c("customer-selection", {
                    attrs: { "hide-check": "" },
                    on: { customerSelection: _vm.selectCustomer }
                  })
                ],
                1
              )
            ],
            1
          ),
          _c(
            "v-stepper-content",
            { staticClass: "ma-0 pa-0", attrs: { step: "1" } },
            [
              _vm.selectedCustomer
                ? _c("health-reports", {
                    attrs: { "customer-id": _vm.selectedCustomer.id }
                  })
                : _vm._e()
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }